import React from "react";

// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import {withStyles} from "@material-ui/core/styles";

// @material-ui/icons

// core components
import Header from "components/Header/Header.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeaderLinks from "./HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";

// Sections for this page
import PortfolioSection from "./Sections/PortfolioSection.jsx";
// import BlogSection from "./Sections/BlogSection.jsx";
import WorkSection from "./Sections/WorkSection.jsx";
import AboutSection from "./Sections/AboutSection.jsx";
import landingPageStyle from "../../assets/jss/material-kit-react/views/landingPage";

import Footer from "./Sections/Footer";

import background1 from "assets/img/business-bg.jpg";
import background2 from "assets/img/developer-bg.jpg";
import background3 from "assets/img/speaker-bg.jpg";

const dashboardRoutes = [];

class LandingPage extends React.Component {
    render() {
        const {classes, ...rest} = this.props;
        return (
            <div className={classNames(classes.root)}>
                <Header
                    color="transparent"
                    routes={dashboardRoutes}
                    brand="Chris Wrobel"
                    rightLinks={<HeaderLinks/>}
                    fixed
                    changeColorOnScroll={{
                        height: 150,
                        color: "white"
                    }}
                    {...rest}
                />
                <Parallax images={[background1, background2, background3]}>
                    <div className={classes.container}>
                        <GridContainer justify={"flex-end"}>
                            <GridItem xs={12} sm={12} md={6}>
                                <h1 className={classes.title}>VR, AR or ML?<br/>Let's talk.</h1>
                                <h4 className={classes.subtitle}>
                                    Entrepreneur, Developer, Speaker and Technology Evangelist helping others embrace
                                    new technologies and grow their businesses.
                                </h4>
                            </GridItem>
                        </GridContainer>
                    </div>
                </Parallax>
                <div className={classNames(classes.main)}>
                    <div className={classes.container}>
                        <AboutSection/>
                    </div>
                </div>
                <div className={classNames(classes.main)}>
                    <div className={classes.container}>
                        <PortfolioSection/>
                    </div>
                </div>
                {/*<div className={classNames(classes.main)}>*/}
                    {/*<div className={classes.container}>*/}
                        {/*<BlogSection/>*/}
                    {/*</div>*/}
                {/*</div>*/}
                <div className={classNames(classes.main)}>
                    <div className={classes.container}>
                        <WorkSection/>
                    </div>
                </div>
                <Footer/>
            </div>
        );
    }
}

export default withStyles(landingPageStyle)(LandingPage);



// WEBPACK FOOTER //
// ./src/views/LandingPage/LandingPage.jsx